import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import Lightbox from 'yet-another-react-lightbox';
import 'yet-another-react-lightbox/styles.css';

export default function Lightbox2({ car, onClose }) {
  const [loanAmount, setLoanAmount] = useState(parseFloat(car.price) || 0);
  const [initialDeposit, setInitialDeposit] = useState(parseFloat(car.price) * 0.4); // 40% default
  const [depositPercent, setDepositPercent] = useState(40);
  const [loanPeriod, setLoanPeriod] = useState('3');
  const [monthlyRepayment, setMonthlyRepayment] = useState(0);

  const formatValue = (value) => {
    return value.toLocaleString('en-NG', { maximumFractionDigits: 2 });
  };

  const handleDepositChange = (e) => {
    const percent = parseInt(e.target.value);
    setDepositPercent(percent);
    const newDeposit = (loanAmount * percent) / 100;
    setInitialDeposit(newDeposit);
  };

  const calculateRepayment = () => {
    const balance = loanAmount - initialDeposit;
    const periods = parseInt(loanPeriod);
    const monthly = balance / periods;
    setMonthlyRepayment(monthly); // Store raw number
  };

  const handleApplyForLoan = async () => {
    try {
      const carName = `${car.make} ${car.model} ${car.year} ${car.color}`;
      await axios.post(`${process.env.REACT_APP_API_URL}/api/loan-applications`, {
        car_name: carName,
        loan_amount: loanAmount,
        initial_deposit: initialDeposit,
        loan_period: `${loanPeriod} months`,
        monthly_repayment: monthlyRepayment,
      });
      navigate('/loan-application', { state: { carName, loanAmount, initialDeposit, loanPeriod, monthlyRepayment } });
    } catch (err) {
      console.error('Error applying for loan:', err.message);
    }
  };

  const navigate = useNavigate();
  const slides = car.images && car.images.length > 0 ? car.images.map(img => ({
    src: img.startsWith('http') ? img : `${process.env.REACT_APP_API_URL}${img}`,
    alt: `${car.make} ${car.model} image`,
  })) : [{ src: 'https://via.placeholder.com/400', alt: 'Placeholder image' }];

  return (
    <Lightbox
      open={true}
      close={onClose}
      slides={slides}
      carousel={{ finite: true, padding: 0, swipe: false }} // Disable swipe navigation
      styles={{ container: { backgroundColor: 'rgba(0, 0, 0, 0.9)' } }}
      render={{
        buttonPrev: () => null,
        buttonNext: () => null,
        slide: () => (
          <div className="relative w-full h-full flex items-center justify-center">
            <img
              src={slides[0].src}
              alt={slides[0].alt}
              className="max-w-full max-h-[70vh] object-contain"
            />
            <div className="absolute inset-0 bg-black bg-opacity-50 flex items-center justify-center">
              <div className="p-4 bg-white rounded-lg max-w-md w-full">
                <h2 className="text-2xl font-bold mb-4">{`${car.make} ${car.model} ${car.year}`}</h2>
                <div className="space-y-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700">Loan Amount (₦)</label>
                    <input
                      type="number"
                      value={loanAmount}
                      readOnly
                      className="w-full p-2 border border-gray-300 rounded-md"
                    />
                    <p className="text-sm text-gray-500 mt-1">{formatValue(loanAmount)}</p>
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700">Initial Deposit (₦)</label>
                    <input
                      type="number"
                      value={initialDeposit}
                      readOnly
                      className="w-full p-2 border border-gray-300 rounded-md"
                    />
                    <p className="text-sm text-gray-500 mt-1">{formatValue(initialDeposit)}</p>
                    <div className="mt-2">
                      <label>Deposit Percentage: {depositPercent}%</label>
                      <input
                        type="range"
                        min="40"
                        max="90"
                        value={depositPercent}
                        onChange={handleDepositChange}
                        className="w-full"
                      />
                    </div>
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700">Loan Period</label>
                    <select
                      value={loanPeriod}
                      onChange={(e) => setLoanPeriod(e.target.value)}
                      className="w-full p-2 border border-gray-300 rounded-md"
                    >
                      <option value="3">3 months</option>
                      <option value="6">6 months</option>
                      <option value="12">12 months</option>
                    </select>
                  </div>
                  <button
                    onClick={calculateRepayment}
                    className="bg-blue-600 text-white p-2 rounded-md hover:bg-blue-700"
                  >
                    Calculate
                  </button>
                  <div>
                    <label className="block text-sm font-medium text-gray-700">Monthly Repayment (₦)</label>
                    <input
                      type="number"
                      value={monthlyRepayment}
                      readOnly
                      className="w-full p-2 border border-gray-300 rounded-md"
                    />
                    <p className="text-sm text-gray-500 mt-1">{formatValue(monthlyRepayment)}</p>
                  </div>
                  <button
                    onClick={handleApplyForLoan}
                    className="bg-green-600 text-white p-2 rounded-md hover:bg-green-700 w-full"
                  >
                    Apply for Loan
                  </button>
                </div>
              </div>
            </div>
          </div>
        ),
      }}
    />
  );
}